"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-54b2b3c4"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "message-tip" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        vue_1.createElementVNode("span", null, vue_1.toDisplayString((_a = _ctx.message) === null || _a === void 0 ? void 0 : _a.text), 1)
    ]));
}
exports.render = render;
